export default {
  bannerIndexData: {
    es: [
      {
        name: 'large',
        imageBanner: '',
        imageDesktopXL: '/assets/images/home-page/banner-home-best-place-work-xl.webp',
        imageDesktop: '/assets/images/home-page/banner-home-best-place-work-desktop.webp',
        imageTablet: '/assets/images/home-page/banner-home-best-place-work-tablet.webp',
        imageMobile: '/assets/images/home-page/banner-home-best-place-work-mobile.webp',
        text1: 'Talento humano',
        text2: 'Transformación digital',
        text3: 'Agilidad',
        class: 'large',
      },
    ],
    en: [
      {
        name: 'large',
        imageBanner: '',
        imageDesktopXL: '/assets/images/home-page/banner-home-best-place-work-xl.webp',
        imageDesktop: '/assets/images/home-page/banner-home-best-place-work-desktop.webp',
        imageTablet: '/assets/images/home-page/banner-home-best-place-work-tablet.webp',
        imageMobile: '/assets/images/home-page/banner-home-best-place-work-mobile.webp',
        text1: 'Human talent',
        text2: 'Digital transformation ',
        text3: 'Agility',
        class: 'large',
      },
    ],
  },
};
